module.exports = __webpack_public_path__ + "public-ui/img/gpb.efaf1031.svg";